import React from 'react'
import {
  SectionPaper,
  SectionTitle,
  SubSectionTitle,
  SubSectionWrapper,
} from 'components/startup/startup-styles'
import { Column } from 'components/common/layout'
import { StartupMember } from 'types/common'
import { TextViewer } from 'components/common/text-editor'
import { TeamMember } from 'components/startup/team-member'
import { checkEditorDefaultValue } from 'utils/validations'
import { theme } from 'infra/theme'
import { StartupChart } from 'components/startup/startup-chart'
import { IS_APP } from 'infra/constants'

export const Team: React.FC<{
  culture: string
  members: StartupMember[]
  startupName: string
  businessNumber: number
}> = ({ culture, members, startupName, businessNumber }) => {
  if (!culture && checkEditorDefaultValue(culture) && !members.length)
    return null
  return (
    <Column id='team'>
      <SectionTitle>팀 문화</SectionTitle>
      <Column style={{ gap: 32 }}>
        {culture && !checkEditorDefaultValue(culture) && (
          <SubSectionWrapper>
            <SubSectionTitle>Q. 조직문화는 어떤가요?</SubSectionTitle>
            <SectionPaper>
              <TextViewer value={culture} />
            </SectionPaper>
          </SubSectionWrapper>
        )}
        {members.length > 0 && (
          <SubSectionWrapper>
            <SubSectionTitle>Q. 어떤 분들과 일하는지 궁금해요</SubSectionTitle>
            <Column style={{ gap: 12 }}>
              {members.map((member) => (
                <TeamMember
                  key={member.id}
                  data={member}
                  backgroundColor={theme.color.background}
                />
              ))}
            </Column>
          </SubSectionWrapper>
        )}
        {!IS_APP && businessNumber && String(businessNumber).length >= 6 && (
          <StartupChart
            startupName={startupName}
            businessNumber={businessNumber}
          />
        )}
      </Column>
    </Column>
  )
}
